<nav class="esn-pagination" [attr.aria-label]="label()" (keydown)="handleKeydown($event)">
  @if (rangeText(); as text) {
    <p class="esn-pagination__range" aria-live="polite">{{ text }}</p>
  }
  <button
    type="button"
    class="esn-pagination__cell esn-pagination__arrow"
    [disabled]="current() <= 1"
    [attr.aria-label]="previousLabel()"
    (click)="go(current() - 1)"
  >
    <span aria-hidden="true">‹</span>
  </button>
  @for (cell of cells(); track $index) {
    @if (cell.kind === 'page') {
      <button
        type="button"
        class="esn-pagination__cell esn-pagination__page"
        [class.esn-pagination__page--current]="cell.page === current()"
        [attr.aria-current]="cell.page === current() ? 'page' : null"
        [attr.aria-label]="pageLabel()(cell.page)"
        (click)="go(cell.page)"
      >
        {{ cell.page }}
      </button>
    } @else {
      <span class="esn-pagination__gap" aria-hidden="true">…</span>
    }
  }
  <button
    type="button"
    class="esn-pagination__cell esn-pagination__arrow"
    [disabled]="current() >= count()"
    [attr.aria-label]="nextLabel()"
    (click)="go(current() + 1)"
  >
    <span aria-hidden="true">›</span>
  </button>
</nav>
